<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}个库房</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">
            {{ cancelButtonText }}
          </el-button>

          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="no" label="库房编码" width="160">
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="库房名称" width="150" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="sourceType" label="库房类型" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.sourceType??'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="categoryName" label="库房级别" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="address" label="位置" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.address??'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="managerName" label="管理员" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="phone" label="联系方式" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="deptNames" label="关联科室" min-width="100">
          <!-- <template slot-scope="scope">
            {{scope.row.deptInfos && scope.row.deptInfos.length > 0 ? scope.row.deptInfos.map(e => e.name).join(';') : ''}}
    
          </template> -->
        </el-table-column>
        <el-table-column prop="isOpenThreeWarehouse" label="三级库启用状态" min-width="140">
          <template slot-scope="scope">
            {{ getBoolName(scope.row.isOpenThreeWarehouse) }}
          </template>
        </el-table-column>
        <el-table-column prop="stateName" label="状态" width="80">
          <template slot-scope="scope">
            <span :class="{
                enable: scope.row.state == 1,
                forbidden: scope.row.state == 0,
              }">{{ scope.row.stateName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operation" fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">{{ scope.row.state === 0 ? "启用" : "禁用" }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <info :show="showInfo" :id="id" @handleClose="closeInfo"></info>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { GetWarehouses, UpdateWarehouseStatesById } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import Info from "./info.vue";
import SelectFilter from "@/components/table-select-filter";
import {
  WarehouseTypeOptions,
} from "@/enum";

export default {
  name: "Warehouse",
  mixins: [GetDataMixin],
  components: {
    Info,
    SelectFilter
  },
  data () {
    return {
      WarehouseTypeOptions:WarehouseTypeOptions,
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 打开详情
      showInfo: false,
      id: 0,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      cancelButtonText: "禁用",

      filterOptions: [
        {
          name: "名称",
          type: "input",
          code: "keyWord",
        },
        {
          name: "科室",
          type: "select",
          code: "deptId",
          filterMethod: this.getDepts,
          data: [],
        },
        {
          name: "库房类型",
          type: "select",
          code: "sourceType",
          data: WarehouseTypeOptions,
        },
      ],
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;

      this.cancelButtonText =
        selection && selection.length > 0 && selection[0].state == 0
          ? "启用"
          : "禁用";
    },
    // 获取列表
    getData () {
      GetWarehouses(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;
      });
    },
    // 查看信息
    handleInfo (row) {
      this.id = row.id;
      this.showInfo = true;
    },
    closeInfo () {
      this.showInfo = false;
      this.id = 0;
    },
    // 新建
    handleAdd () {
      this.$router.push("/warehouse-edit");
    },
    // 编辑
    handleUpdate (row) {
      this.$router.push("/warehouse-edit?id=" + row.id);
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 删除部门
    handleDelete (row) {
      let ids = [];
      let state = 0;
      if (row && row.id) {
        ids = [row.id];
        state = row.state == 1 ? 0 : 1;
      } else {
        state = this.multipleSelection[0].state == 1 ? 0 : 1;
        let stateDatas = this.multipleSelection.filter((e) => e.state == state);
        if (stateDatas.length >= 1) {
          this.$my_message("请只选择一种状态的数据！", "warning");
          return;
        }
        ids = this.ids;
      }
      // const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm(
        row.state == 1
          ? "当前库房关联的有资产，确定仍然要禁用吗？"
          : "确认启用当前库房吗",
        "提示",
        {
          type: "warning",
        }
      )
        .then(() => {
          return UpdateWarehouseStatesById({ ids, state });
        })
        .then(() => {
          this.$my_message(`操作成功`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        orgCode :sessionStorage.getItem('orgId'),
        sourceType :0
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    filterChange (query) {
      this.query = Object.assign(this.query, query);
      this.getData();
    },

  },
  mounted () {
    this.query.sourceType = 0
    this.getData();
  },
};
</script>

<style lang="scss"></style>
